import { type MCPServerInfo } from '../../types';

const PagerDutyRemoteServer: MCPServerInfo = {
  serverId: 'PAGERDUTY',
  name: 'PagerDuty',
  slug: 'pagerduty',
  description:
    'Official PagerDuty remote MCP server. Manage incidents, services, teams, schedules, escalation policies, on-call rotations, and alert grouping for incident response automation.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.pagerduty.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default PagerDutyRemoteServer;
